import { FC } from 'react'
import './FavoriteMovie.scss'
import { IMovies } from '../../models/IMovies'
import { Link } from 'react-router-dom'
import noImg from '../../assets/img/no-img.webp'
import svg from "../../assets/img/sprite.svg";
import { favoritesApi } from '../../redux/services/favoritesApi'

interface FavoriteMovieProps {
    favoriteMovie: IMovies
}

export const FavoriteMovie: FC<FavoriteMovieProps> = ({ favoriteMovie }) => {

    /* Удаление фильма из любимых */
    const [delFavorites] = favoritesApi.useDelFavoritesMutation()

    const handleDelFavorite = async () => {
        await delFavorites(String(favoriteMovie && favoriteMovie.id))
    }

    return (
        <article className='favorite-movie'>
            <button onClick={handleDelFavorite} className="favorite-movie__del" >
                <svg width="30" height="30">
                    <use xlinkHref={`${svg}#x`}></use>
                </svg>
            </button>
            <Link className='' to={`/movie/${favoriteMovie.id} `} > {/*  */}
                <img className='favorite-movie__img' src={favoriteMovie.posterUrl !== null ? favoriteMovie.posterUrl : noImg} alt={favoriteMovie.title} />
            </Link>

        </article>

    )
}